<div class="header">
  <h3 style="margin-bottom: 1vw; margin-top: 40px">
    {{ "curious" | transloco }}
  </h3>
  <h1 style="margin-bottom: 20px; margin-top: 10px">
    {{ "askus" | transloco }}
  </h1>
  <div style="width: 100px; border: solid 1px #237ae0; margin: 3vw auto"></div>
</div>
<div class="questions-form">
  <form
    id="ask-us-anything-form"
    style="width: 80%"
    [formGroup]="askUsForm"
    (ngSubmit)="sendMessage()"
  >
    <div id="input-wrapper">
      <div class="input-div">
        <label for="fname"
          ><h3>{{ "name" | transloco }}:</h3></label
        ><br />
        <input
          required
          type="text"
          id="fname"
          name="fname"
          formControlName="name"
        /><br />
      </div>
      <div class="input-div">
        <label for="message"
          ><h3>{{ "email" | transloco }}:</h3></label
        ><br />
        <input required type="email" id="email" formControlName="email" /><br />
      </div>
    </div>
    <label for="message"
      ><h3>{{ "message" | transloco }}:</h3></label
    ><br />
    <textarea
      required
      type="text"
      id="message"
      name="message"
      value=""
      formControlName="message"
    ></textarea
    ><br />
    <div class="button-div">
      <button class="button" type="submit" [disabled]="!askUsForm.valid">
        {{ "Submit" | transloco }}
      </button>
    </div>
    <div class="feedback-message" *ngIf="submitted">
      <h2>{{ "thankyou" | transloco }}</h2>
    </div>
  </form>
</div>
